// TODO rewrite with named imports/exports
import defaultsMode from './defaultsMode';
import strictMode from './strictMode';

export default {
	defaultsMode: defaultsMode,
	strictMode: strictMode
};
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/index.js.01-babel.map